import { c as _c } from "react/compiler-runtime";
import React from 'react';
export default function Loading() {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-6 w-5/6 rounded-full bg-spindle" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full animate-pulse flex-col gap-y-8 p-4">{t0}<div className="w-full"><div className="mx-auto h-96 w-96 rounded-full bg-spindle" /></div></div>;
    t2 = <div className="h-full border-r border-spindle" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={"\n                h-6 w-48 rounded-full bg-spindle\n                xl:w-64\n              "} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-y-4">{[...Array(7).keys()].map(_temp)}</div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-y-4"><div className="h-32 w-10 rounded-lg bg-spindle" /><div className={"\n                        h-3 w-10 rounded-lg bg-spindle\n                        lg:h-5\n                      "} /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-col gap-y-4"><div className="h-16 w-10 rounded-lg bg-spindle" /><div className={"\n                        h-3 w-10 rounded-lg bg-spindle\n                        lg:h-5\n                      "} /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col gap-y-4"><div className="h-2 w-10 rounded-lg bg-spindle" /><div className={"\n                        h-3 w-10 rounded-lg bg-spindle\n                        lg:h-5\n                      "} /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex flex-col gap-y-4"><div className="h-8 w-10 rounded-lg bg-spindle" /><div className={"\n                        h-3 w-10 rounded-lg bg-spindle\n                        lg:h-5\n                      "} /></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={"\n            flex w-full flex-col gap-4\n            lg:flex-row\n          "}>{t1}{t2}<div className="flex w-full animate-pulse flex-col gap-x-4 p-4">{t3}<div className={"\n                mt-12 flex flex-col\n                lg:mt-32\n              "}><div className={"\n                  flex gap-x-6\n                  xl:gap-x-16\n                "}>{t4}<div className={"\n                    flex items-end gap-x-6\n                    xl:gap-x-16\n                  "}>{t5}{t6}{t7}{t8}<div className="flex flex-col gap-y-4"><div className="h-24 w-10 rounded-lg bg-spindle" /><div className={"\n                        :w-10\n                        h-3 rounded-lg bg-spindle\n                        lg:h-5\n                      "} /></div></div></div></div></div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className={"\n          flex h-min w-full flex-col gap-4 rounded-lg bg-smoke p-4\n          lg:w-3/4\n        "}>{t9}<div className="flex animate-pulse flex-col gap-8"><div className="h-6 w-1/2 rounded-full bg-spindle" /><div className="h-144 w-full rounded-lg bg-spindle" /></div></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <><div className={"\n        flex flex-col gap-8\n        lg:flex-row\n      "}>{t10}<div className={"\n          flex w-full animate-pulse flex-col gap-y-8\n          lg:w-1/4\n        "}><div className="h-min w-full rounded-lg bg-smoke p-4"><div className="flex w-full flex-col gap-y-6"><div className="h-6 w-2/3 rounded-full bg-spindle" /><div className="h-16 w-1/2 rounded-lg bg-spindle" /></div></div>{[...Array(3).keys()].map(_temp2)}</div></div></>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
}
function _temp2(v_0) {
  return <div key={`skeleton.places.${v_0}`}><div className="mb-2 h-8 w-32 rounded-lg bg-smoke" /><div className="mb-4 w-full border-b" />{[...Array(3).keys()].map(x => <div key={`skeleton.places.${v_0}.${x}`} className="py-2"><div className="flex gap-x-4"><div className="h-6 w-6 rounded-full bg-smoke" /><div><div className="mb-2 h-6 w-32 rounded-lg bg-smoke" /><div className="mb-2 h-4 w-48 rounded-lg bg-smoke" /></div></div></div>)}</div>;
}
function _temp(v) {
  return <div key={`skeleton.axis.${v}`} className={"\n                          h-3 w-10 rounded-lg bg-spindle\n                          lg:h-5\n                        "} />;
}